import { RequirePermission } from '@saniplus/ui';
import type { RouteObject } from 'react-router';

import { AccesRedirect } from './components/AccesRedirect';
import { PermissionFallback } from '../../components/shared/PermissionFallback';

/**
 * The personnel routes, code-split per screen (D-14 / the PM routing decision).
 *
 * Exported as a plain array for the integrator to spread into
 * `app/router.tsx` under `AppLayout`; this feature does not own the router.
 *
 * The two employee screens are gated on `user:read`, which is the permission
 * `GET /users` itself demands.
 *
 * `RequirePermission` renders a fallback rather than redirecting, because
 * silently sending somebody elsewhere reads as a broken link. It is not a
 * security control: the API answers 403/404 on its own, and an out-of-scope
 * read answers 404 by design.
 *
 * `/personnel/acces` is no longer a screen: A23 is a tab of the employee
 * record, and the path stays mounted only to forward the old deep link
 * (`AccesRedirect`). It gates on nothing because it renders nothing.
 */
export const routes: RouteObject[] = [
  {
    path: '/personnel/employes',
    lazy: async () => {
      const { EmployeesPage } = await import('./pages/EmployeesPage');
      return {
        Component: () => (
          <RequirePermission permission="user:read" fallback={<PermissionFallback />}>
            <EmployeesPage />
          </RequirePermission>
        ),
      };
    },
  },
  {
    path: '/personnel/employes/:id',
    lazy: async () => {
      const { EmployeeDetailPage } = await import('./pages/EmployeeDetailPage');
      return {
        Component: () => (
          <RequirePermission permission="user:read" fallback={<PermissionFallback />}>
            <EmployeeDetailPage />
          </RequirePermission>
        ),
      };
    },
  },
  {
    path: '/personnel/acces',
    Component: AccesRedirect,
  },
];
